import { Footer } from "antd/es/layout/layout"
import React from "react"

function Foot(props:any){
  return (
      <Footer style={{ textAlign: "center" }}>© 2025 Ryo Solutions</Footer>
  )
}

export default Foot